export const DATE_LOCALE = "ca";

export const COD_LABORAL: string = "LAB";
export const COD_FAMILIAR: string = "FAM";
export const COD_ENTRENAMIENTO: string = "ENT";

export const COD_ENSENANZA_INFANTIL: string = "1";
export const COD_ENSENANZA_PRIMARIA: string = "2";

export const DOC_NIF: string = "N";
export const DOC_NIE: string = "E";
export const DOC_CIF: string = "C";
export const DOC_OTROS: string = "O";
export const DOC_PASAPORTE: string = "P";

export const COD_ADJUDICACION_PRO: string = "PRO";
export const COD_ADJUDICACION_DEF: string = "DEF";
export const ID_PAIS_ESPANA :number= 75;
export const PREF_TEL_ESPANA :number= 34;
